<template>
  <div class="xjsrdzd-container">
    <el-row class="tcf-row">
      <el-col class="card">
        <div class="card-body">
          <!-- 搜索条件 -->
          <el-form :inline="true" size="small" :model="searchForm" @submit.native.prevent>
            <el-form-item label="打款日期">
              <el-date-picker
                v-model="searchForm.time"
                format="yyyy年MM月dd日"
                value-format="yyyy-MM-dd"
                type="daterange"
                style="width:300px"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
              />
            </el-form-item>
            <el-form-item label="收款类型">
              <el-select v-model="searchForm.type" style="width: 130px" clearable>
                <el-option label="意向金" :value="0" />
                <el-option label="样品预存款" :value="1" />
              </el-select>
            </el-form-item>
            <br>
            <el-form-item label="收款账户">
              <el-select v-model="searchForm.aid" style="width:300px" placeholder="请选择" clearable filterable>
                <el-option-group
                  v-for="gitem in groupList"
                  v-if="gitem.nature===0"
                  :key="gitem.groupid"
                  :label="gitem.account_name"
                >
                  <el-option
                    v-for="item in accountsList"
                    v-if="item.groupid===gitem.groupid"
                    :key="item.aid"
                    :label="item.name+'（'+item.card+'）'"
                    :value="item.aid"
                  >
                    <span style="float: left">{{ item.name }}</span>
                    <span style="float: right; color: #8492a6; font-size: 13px">{{ item.card }}</span>
                  </el-option>
                </el-option-group>
              </el-select>
            </el-form-item>
            <el-form-item label="关键字">
              <el-input v-model="searchForm.search" style="width:200px" placeholder="关键字搜索" @keyup.enter.native="Search" />
            </el-form-item>
            <el-form-item>
              <el-button icon="el-icon-search" @click="Search()">搜索</el-button>
            </el-form-item>
            <el-form-item>
              <el-button icon="el-icon-printer" :loading="pringLoading" @click="print">打印对账单</el-button>
            </el-form-item>
            <el-form-item>
              <el-button icon="el-icon-printer" :loading="excelLoading" @click="exportExcel">导出Excel</el-button>
            </el-form-item>
          </el-form>
          <!-- 表格内容 -->
          <div class="card-content">
            <el-table
              v-loading="loading"
              :data="tableData"
              stripe
              :row-style="{cursor: 'pointer'}"
              style="width: 100%"
              @row-click="openDetails"
            >
              <el-table-column
                label="收款类型"
                width="80"
                align="center"
                show-overflow-tooltip
              >
                <template slot-scope="scope">
                  <span>{{ scope.row.payType==0?'意向金':'样品预存款' }}</span>
                </template>
              </el-table-column>
              <el-table-column
                label="客户"
                width="100"
                align="center"
                show-overflow-tooltip
              >
                <template slot-scope="scope">
                  <span>{{ scope.row.clientName }}</span>
                </template>
              </el-table-column>
              <el-table-column
                label="客户电话"
                width="110"
                align="center"
                show-overflow-tooltip
              >
                <template slot-scope="scope">
                  <span>{{ scope.row.clientTel }}</span>
                </template>
              </el-table-column>
              <el-table-column
                label="省"
                width="100"
                align="center"
                show-overflow-tooltip
              >
                <template slot-scope="scope">
                  <span>{{ scope.row.province }}</span>
                </template>
              </el-table-column>
              <el-table-column
                label="市"
                width="90"
                align="center"
                show-overflow-tooltip
              >
                <template slot-scope="scope">
                  <span>{{ scope.row.city }}</span>
                </template>
              </el-table-column>
              <el-table-column
                label="区"
                width="80"
                align="center"
                show-overflow-tooltip
              >
                <template slot-scope="scope">
                  <span>{{ scope.row.county }}</span>
                </template>
              </el-table-column>
              <!-- <el-table-column
                label="客户区域"
                width="160"
                align="center"
                show-overflow-tooltip
              >
                <template slot-scope="scope">
                  <span>{{ scope.row.province+scope.row.city+scope.row.county }}</span>
                </template>
              </el-table-column> -->
              <el-table-column
                label="意向金"
                width="90"
                align="center"
                show-overflow-tooltip
              >
                <template slot-scope="scope">
                  <span>{{ scope.row.intent }}</span>
                </template>
              </el-table-column>
              <el-table-column
                label="样品预存款"
                width="90"
                align="center"
                show-overflow-tooltip
              >
                <template slot-scope="scope">
                  <span>{{ scope.row.joinn }}</span>
                </template>
              </el-table-column>
              <el-table-column
                label="加盟费"
                width="90"
                align="center"
                show-overflow-tooltip
              >
                <template slot-scope="scope">
                  <span>{{ scope.row.insure }}</span>
                </template>
              </el-table-column>
              <el-table-column
                label="打款卡号"
                width="140"
                align="center"
                show-overflow-tooltip
              >
                <template slot-scope="scope">
                  <span>{{ scope.row.card }}</span>
                </template>
              </el-table-column>
              <el-table-column
                label="收款账户"
                width="180"
                align="center"
                show-overflow-tooltip
              >
                <template slot-scope="scope">
                  <span>{{ scope.row.accountName }}</span>
                </template>
              </el-table-column>
              <el-table-column
                label="收款卡号"
                width="160"
                align="center"
                show-overflow-tooltip
              >
                <template slot-scope="scope">
                  <span>{{ scope.row.accountCard }}</span>
                </template>
              </el-table-column>
              <!-- <el-table-column
                label="收款账户"
                width="260"
                align="center"
                show-overflow-tooltip
              >
                <template slot-scope="scope">
                  <span>{{ scope.row.accountName }}({{ scope.row.accountCard }})</span>
                </template>
              </el-table-column> -->
              <el-table-column
                label="备注"
                width="160"
                align="center"
                show-overflow-tooltip
              >
                <template slot-scope="scope">
                  <span>{{ scope.row.remark }}</span>
                </template>
              </el-table-column>
              <el-table-column
                label="收款金额"
                width="100"
                align="center"
                fixed="right"
                show-overflow-tooltip
              >
                <template slot-scope="scope">
                  <span style="color:#409EFF;font-weight: 500;">{{ scope.row.money }}</span>
                </template>
              </el-table-column>
              <el-table-column
                label="打款时间"
                width="100"
                align="center"
                fixed="right"
                show-overflow-tooltip
              >
                <template slot-scope="scope">
                  <span>{{ scope.row.receiptTime }}</span>
                </template>
              </el-table-column>
              <el-table-column
                label="负责人"
                width="120"
                fixed="right"
                align="center"
                show-overflow-tooltip
              >
                <template slot-scope="scope">
                  {{ scope.row.userName }}
                </template>
              </el-table-column>
            </el-table>
            <el-pagination
              v-if="total>0"
              background
              :current-page="currentPage"
              :page-sizes="[20, 50, 100]"
              :page-size="pageSize"
              layout="total, sizes, prev, pager, next, jumper"
              :total="total"
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
            />
          </div>
        </div>
      </el-col>
    </el-row>
    <!-- 样品预存款收款明细 -->
    <el-dialog
      title="样品预存款收款明细"
      :visible.sync="jmDetailVisible"
      width="40%"
      :destroy-on-close="true"
      :lock-scroll="true"
      :append-to-body="true"
    >
      <table v-loading="jmFullscreenLoading" class="tcf-detail-table">
        <tr>
          <th>申请人</th>
          <td>{{ jmDetail.apply_name }}</td>
          <th>申请时间</th>
          <td>{{ jmDetail.time }}</td>
        </tr>
        <tr>
          <th>店面形式</th>
          <td>{{ jmDetail.shopform===1?'店中店':jmDetail.shopform===2?'沿街店':'商场内店' }}</td>
          <th>门店地址</th>
          <td>{{ jmDetail.address }}</td>
        </tr>
        <tr>
          <th>总面积</th>
          <td>{{ jmDetail.totalarea }}</td>
          <th>本品牌<br />占店面积</th>
          <td>{{ jmDetail.area }}</td>
        </tr>
        <tr>
          <th>客户</th>
          <td>{{ jmDetail.all_name }}</td>
          <th>卡号</th>
          <td>{{ jmDetail.card_num }}</td>
        </tr>
        <tr>
          <th>打款账户</th>
          <td colspan="3">
            {{ jmDetail.accountname }}（{{ jmDetail.accountcard }}）
            <!-- <span v-for="av in jmDetail.accountVoList" v-if="av.is_select===1" :key="av.card">{{ av.account_name }}（{{ av.card }}）</span> -->
          </td>
        </tr>
        <tr>
          <th>打款日期</th>
          <td>{{ jmDetail.pay_time }}</td>
          <th>打款金额</th>
          <td>{{ jmDetail.pay_price }}（样品预存款：{{ jmDetail.joins }}，加盟费：{{ jmDetail.insure }}）</td>
        </tr>
        <tr>
          <th>打款凭证</th>
          <td colspan="3">
            <el-image
              v-for="iurl in jmImgSrcList"
              :key="iurl"
              style="width: 60px; height: 60px;margin-right: 10px;margin-bottom: 10px"
              :src="iurl"
              :preview-src-list="jmImgSrcList"
            />
          </td>
        </tr>
        <tr>
          <th>备注</th>
          <td colspan="3">{{ jmDetail.remark }}</td>
        </tr>
        <tr v-if="jmDetail.joinType===0 && (jmDetail.mark===1||jmDetail.mark===2||jmDetail.mark===4||jmDetail.mark===9)">
          <th>招商总监</th>
          <td>{{ jmDetail.dirname }}</td>
          <th>审核时间</th>
          <td colspan="3">{{ jmDetail.dirtime }}</td>
        </tr>
        <tr v-if="jmDetail.mark===2||jmDetail.mark===4||jmDetail.mark===9 || (jmDetail.joinType===1 && jmDetail.mark>0)">
          <th>财务审核</th>
          <td>{{ jmDetail.auditname }}</td>
          <th>审核时间</th>
          <td>{{ jmDetail.audittime }}</td>
        </tr>
        <tr v-if="jmDetail.mark===4 || (jmDetail.joinType===1 && jmDetail.mark===1)">
          <th>财务驳回原因</th>
          <td colspan="3" style="color:#f56c6c">{{ jmDetail.rson }}</td>
        </tr>
        <tr v-if="((jmDetail.joinType===0&&jmDetail.mark===1) || (jmDetail.joinType===1&&jmDetail.mark===0)) && jmDetail.rson">
          <th>上次驳回</th>
          <td colspan="3" style="color:#f56c6c">{{ jmDetail.rson }}</td>
        </tr>
      </table>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="jmDetailVisible = false">关闭</el-button>
      </span>
    </el-dialog>
    <!-- 意向金收款明细 -->
    <el-dialog
      title="意向金收款明细"
      :visible.sync="yxDetailVisible"
      width="40%"
      :destroy-on-close="true"
      :lock-scroll="true"
      :append-to-body="true"
    >
      <table v-loading="yxFullscreenLoading" class="tcf-detail-table">
        <tr>
          <th>申请日期</th>
          <td>{{ yxDetail.time }}</td>
          <th>意向加盟地区</th>
          <td>{{ yxDetail.province }}{{ yxDetail.city }}</td>
          <th>意向加盟品牌</th>
          <td>{{ yxDetail.brandname }}</td>
        </tr>
        <tr>
          <th>客户姓名</th>
          <td>{{ yxDetail.name }}</td>
          <th>联系电话</th>
          <td>{{ yxDetail.tel }}</td>
          <th>招商经理</th>
          <td>{{ yxDetail.username }}</td>
        </tr>
        <tr>
          <th>意向金享受权限</th>
          <td colspan="5">{{ yxDetail.enjoy }}</td>
        </tr>
        <tr>
          <th>打款账户</th>
          <td colspan="5">{{ yxDetail.accountsname }}（{{ yxDetail.accountscard }}）</td>
        </tr>
        <tr>
          <th>意向金</th>
          <td style="color: #409EFF;font-weight: bold">{{ yxDetail.money }}</td>
          <th>打款日期</th>
          <td>{{ yxDetail.receipttime }}</td>
          <th>打款卡号</th>
          <td>{{ yxDetail.card }}</td>
        </tr>
        <tr>
          <th>打款凭证</th>
          <td colspan="5">
            <el-image
              v-for="iurl in yxImgSrcList"
              :key="iurl"
              style="width: 60px; height: 60px;margin-right: 10px;margin-bottom: 10px"
              :src="iurl"
              :preview-src-list="yxImgSrcList"
            />
          </td>
        </tr>
        <tr>
          <th>备注</th>
          <td colspan="5">{{ yxDetail.remark }}</td>
        </tr>
        <tr v-if="yxDetail.mark===1||yxDetail.mark===2||yxDetail.mark===4||yxDetail.mark===9">
          <th>招商总监</th>
          <td>{{ yxDetail.dirname }}</td>
          <th>审核时间</th>
          <td colspan="3">{{ yxDetail.dirtime }}</td>
        </tr>
        <tr v-if="yxDetail.mark===2||yxDetail.mark===4||yxDetail.mark===9">
          <th>财务审核</th>
          <td>{{ yxDetail.auditname }}</td>
          <th>审核时间</th>
          <td colspan="3">{{ yxDetail.audittime }}</td>
        </tr>
        <tr v-if="yxDetail.mark===4">
          <th>财务驳回原因</th>
          <td colspan="5" style="color:#f56c6c">{{ yxDetail.rson }}</td>
        </tr>
      </table>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="yxDetailVisible = false">关闭</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { getUser } from '@/utils/auth'
import { getAccounts, getGroupReport } from '@/api/pub'
import { getMerchantsMoneyDetail, getClientInmonDetail } from '@/api/work'
import { getBusinessStatement, excelBusinessStatement, printBusinessStatement, getDealerJoinApplyById } from '@/api/erp'
import { getLodop } from '@/common/Lodop/LodopFuncs'

export default {
  name: 'Zsdzd',
  data() {
    return {
      groupList: [],
      accountsList: [],
      currentPage: 1,
      pageSize: 20,
      total: 0,
      searchForm: {
        time: [],
        type: null,
        aid: null,
        groupid: null,
        search: null
      },
      tableData: [],
      loading: false,
      pringLoading: false,
      excelLoading: false,
      // 样品预存款信息
      jmFullscreenLoading: false,
      jmDetailVisible: false,
      jmDetail: [],
      jmImgSrcList: [],
      // 意向金信息
      yxFullscreenLoading: false,
      yxDetailVisible: false,
      yxDetail: [],
      yxImgSrcList: []
    }
  },
  computed: {
    user: getUser
  },
  created() {
    getGroupReport().then(response => {
      this.groupList = response.data
    }).catch(() => {})
    getAccounts().then(response => {
      this.accountsList = response.data
    }).catch(() => {})
    this.getData()
  },
  methods: {
    Search() {
      this.currentPage = 1
      this.getData()
    },
    handleSizeChange(val) {
      this.pageSize = val
      this.getData()
    },
    handleCurrentChange(val) {
      this.currentPage = val
      this.getData()
    },
    getData() {
      this.loading = true
      let starttime = ''
      let endtime = ''
      if (this.searchForm.time !== null && this.searchForm.time !== undefined) {
        if (this.searchForm.time.length === 2) {
          starttime = this.searchForm.time[0]
          endtime = this.searchForm.time[1]
        }
      }
      const data = {
        aid: this.searchForm.aid,
        type: this.searchForm.type,
        content: this.searchForm.search,
        starttime: starttime,
        endtime: endtime,
        page: this.currentPage,
        limit: this.pageSize,
        groupid: this.user.dGroupid
      }
      getBusinessStatement(data).then(response => {
        this.tableData = response.data
        this.total = response.total
        this.loading = false
      }).catch(() => {
        this.loading = false
      })
    },
    openDetails(row) {
      // 样品预存款申请
      if (row.payType === 1 && row.joinType === 1) {
        this.jmImgSrcList = []
        this.jmFullscreenLoading = true
        this.jmDetailVisible = true
        getDealerJoinApplyById({
          djaid: row.id,
		  userid: this.user.dUserid
        }).then(response => {
          this.jmDetail = response.data || {}
          const imgs = []
          for (const c of this.jmDetail.imgList) {
            imgs.push(c.img_url)
          }
          this.jmImgSrcList = imgs
          this.jmFullscreenLoading = false
        }).catch(() => {
          this.jmFullscreenLoading = false
        })
        return
      }
      if (row.payType === 0) {
        this.yxImgSrcList = []
        this.yxDetailVisible = true
        this.yxFullscreenLoading = true
        getClientInmonDetail({ ciid: row.id }).then(response => {
          this.yxFullscreenLoading = false
          this.yxDetail = response.data
          const imgs = []
          for (const c of this.yxDetail.imglst) {
            imgs.push(c.imgurl)
          }
          this.yxImgSrcList = imgs
        }).catch(() => {
          this.yxFullscreenLoading = false
        })
      } else if (row.payType === 1) {
        this.jmImgSrcList = []
        this.jmDetailVisible = true
        this.jmFullscreenLoading = true
        getMerchantsMoneyDetail({ payid: row.id, userid: this.user.dUserid }).then(response => {
          this.jmFullscreenLoading = false
          this.jmDetail = response.data
          const imgs = []
          for (const c of this.jmDetail.imgList) {
            imgs.push(c.img_url)
          }
          this.jmImgSrcList = imgs
        }).catch(() => {
          this.jmFullscreenLoading = false
        })
      }
    },
    print() {
      const LODOP = getLodop()
      if (LODOP !== null && LODOP !== undefined) {
        if (!this.pringLoading) {
          let starttime = ''
          let endtime = ''
          if (this.searchForm.time !== null && this.searchForm.time !== undefined) {
            if (this.searchForm.time.length === 2) {
              starttime = this.searchForm.time[0]
              endtime = this.searchForm.time[1]
            }
          }
          if (this.total > 400) {
            if (starttime === '' && endtime === '') {
              this.$message({
                message: '由于数据量过多，请选择打款日期或操作日期区间再打印',
                type: 'warning'
              })
              return false
            }
          }
          this.pringLoading = true
          const data = {
            aid: this.searchForm.aid,
            type: this.searchForm.type,
            content: this.searchForm.search,
            starttime: starttime,
            endtime: endtime,
            groupid: this.user.dGroupid
          }
          printBusinessStatement(data).then(response => {
            this.pringLoading = false
            LODOP.PRINT_INIT('招商收款对账单打印')
            LODOP.SET_PRINT_PAGESIZE(2, 0, 0, 'A4')
            LODOP.SET_PRINT_MODE('PRINT_PAGE_PERCENT', 'Auto-Width')
            LODOP.ADD_PRINT_TABLE(30, 1, '100%', '100%', response.data)
            LODOP.SET_PRINT_STYLEA(0, 'HOrient', 3)
            LODOP.SET_PRINT_STYLEA(0, 'VOrient', 3)
            LODOP.SET_SHOW_MODE('LANDSCAPE_DEFROTATED', 1)
            LODOP.NewPageA()
            LODOP.SET_PRINT_STYLEA(0, 'HtmWaitMilSecs', 100)
            LODOP.PREVIEW()
          }).catch(() => {
            this.pringLoading = false
          })
        }
      }
    },
    exportExcel() {
      let starttime = ''
      let endtime = ''
      if (this.searchForm.time !== null && this.searchForm.time !== undefined) {
        if (this.searchForm.time.length === 2) {
          starttime = this.searchForm.time[0]
          endtime = this.searchForm.time[1]
        }
      }
      if (this.total > 400) {
        if (starttime === '' && endtime === '') {
          this.$message({
            message: '由于数据量过多，请选择打款日期区间再导出',
            type: 'warning'
          })
          return false
        }
      }
      this.$message({
        message: '数据正在导出，请稍候'
      })
      this.excelLoading = true
      const data = {
        aid: this.searchForm.aid,
        type: this.searchForm.type,
        content: this.searchForm.search,
        starttime: starttime,
        endtime: endtime,
        groupid: this.user.dGroupid
      }
      excelBusinessStatement(data).then(response => {
        const _this = this
        const xhr = new XMLHttpRequest()
        xhr.open('GET', response.data.dPath, true)
        xhr.responseType = 'blob'
        xhr.onload = function() {
          if (this.status === 200) {
            const blob = this.response
            const a = document.createElement('a')
            a.download = response.data.dName + '.' + response.data.dType
            a.href = window.URL.createObjectURL(blob)
            a.target = '_blank'
            a.click()
            _this.excelLoading = false
            const h = _this.$createElement
            _this.$msgbox({
              title: '下载提示',
              message: h('div', { attrs: { style: 'letter-spacing:1px;padding-left: 15px;line-height: 22px;' }}, [
                h('span', null, `文件已下载，如文件未下载成功，请关闭相应浏览器拦截，`),
                h('a',
                  { attrs: {
                    href: window.URL.createObjectURL(blob),
                    target: '_blank',
                    download: `${response.data.dName}.${response.data.dType}`,
                    style: 'color: #409EFF;text-decoration:underline;'
                  }}, `点击这里`),
                h('span', null, `重新下载。`)
              ]),
              showCancelButton: false,
              confirmButtonText: '关闭',
              beforeClose: (action, instance, done) => {
                done()
              }
            }).then(action => {
            })
          }
        }
        xhr.send()
      }).catch(() => {
        this.excelLoading = false
      })
    }
  }
}
</script>

<style scoped>

</style>
